import Partners from './partners-view';

export default Partners;
